<style lang="less" scoped>
body{
	background: #fafafa;
}
.Acctplus_profit_list{
	.account_head{
		border-bottom: 0;
	}
	.list{
		padding: 16px 16px 0;
		.item{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			margin-bottom: 15px;
			background: #fff;
			color: #999;
			font-size: 14px;
			.line{
				height: 35px;
				box-sizing: border-box;
				padding: 0 12px;
				min-width: 50%;
				display: -webkit-box; display:flex;
				background: #c7c7c7;
				-webkit-box-align: center; align-items: center;
				color: #fff;
			}
			.active{
				background: #dc2a2a;
				font-weight: 700;
			}
			.time{
				font-weight: 700;
				-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
			}
			.detail{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				display: -webkit-box; display:flex;
				justify-content: flex-end;
				span{
					font-weight: 700;
				}
			}
		}
	}
	.empty{
		padding-top: 20px;
		font-size: 12px;
		font-weight: 700;
		color: #999;
		text-align: center;
	}
}
</style>

<template>
	<!-- Main Acctplus_profit_list -->
	<section class="Acctplus_profit_list">
		<div class="empty_list" v-if="list.length === 0 && !loading">
			<img src="../assets/empty_order_list.png">
			<h3>暂无收益</h3>
		</div>
		<template v-else>

			<div class="account_head">
				<h1 class="price NOFont">{{info.total_profit}}</h1>
				<div class="desc">
					<p>总收益（元）</p>
				</div>
			</div>

			<div class="list">
				<div class="item" v-for="item in list" :key="item.id">
					<div class="line" :style="'width: '+item.w+'%'" v-if="item.type == 1">
						<div class="time">{{item.day}}</div>
						<div class="detail">
							<span>{{item.profit}}</span>
						</div>
					</div>
					<div class="line active" style="width: 100%" v-if="item.type == 2">
						<div class="time">{{item.day}}</div>
						<div class="detail">
							{{item.t}} 买入 {{item.amt}} 元，预计 {{item.pt}} 起息
						</div>
					</div>
				</div>
				<div class="empty" v-if="list.length >= info.total || list.length > 10">
					<h3>没有更多了</h3>
				</div>
			</div>

		</template>

	</section>
</template>

<script>
	import android from '@flyme/jr/js/android.js';

	import axios from '../axios.js';
	import apis from '../apis.js';
	// import config from '../config.js';

	export default {
		data: function () {
			return {
				loading: false,
				info: {},
				list: []
			};
		},
		components: {
		},
		mounted: function () {
			android('startLoading', {mes: '正在加载'});
			this.watchScroll();
		},
		methods: {
			getList: function (index) {
				let _this = this;
				if (_this.loading) {
					return;
				}
				_this.loading = true;
				axios.post(apis.acctplus_profit_list, {
					index: index
				}).then(function(d) {
					console.log('acctplus_profit_list', index, d, d.value.data_infos, !d.value.data_infos);
					android('stopLoading');
					if (!d.value.data_infos) {
						_this.loading = false;
						return;
					}
					var listdata = d.value.data_infos ;

					for( var i in listdata){
						listdata[i].day = '';
						listdata[i].w = '50';
						if (listdata[i].type == 2) {
							listdata[i].t = '';
							listdata[i].pt = '';
						}
					}

					if (_this.list.length > 0) {
						_this.list = _this.list.concat(listdata);
					}else{
						_this.list = listdata;
					}

					_this.info = d.value;
					_this.calListWidth();

					_this.loading = false;
					setTimeout(function () {
						console.log('get list set time out');
						_this.watchScroll();
					}, 500);
				});
			},
			calListWidth: function () {
				var max = 0;
				for( var i in this.list){
					this.list[i].day = new Date(this.list[i].profit_time).Format("MM/dd");
					if (this.list[i].profit > max) {
						max = this.list[i].profit;
					}
				}
				for( var n in this.list){
					this.list[n].w = Math.floor(100 * this.list[n].profit/max)/2 + 50;
					if (this.list[n].type == 2) {
						this.list[n].t = new Date(this.list[i].trade_time).Format("hh:ss");
						this.list[n].pt = new Date(this.list[i].profit_time).Format("MM/dd");
					}
				}
			},
			isScrollToPageBottom: function () {
				var documentHeight = document.documentElement.offsetHeight;
				var viewPortHeight = window.innerHeight;
				var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

				return documentHeight - viewPortHeight - scrollHeight < 20;
			},
			watchScroll: function (){
				let _this = this;
				console.log('watchScroll', this.isScrollToPageBottom());
				if(!this.isScrollToPageBottom()){
					setTimeout( _this.watchScroll, 900);
					return;
				}
				var index = 0;
				if (this.list.length > 0) {
					index = this.list[this.list.length-1].index;
				}
				if (!this.loading) {
					this.getList(index);
				}
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_profit_list.vue